import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BellRing } from 'lucide-react';
import { api } from '@/lib/pos-api';

export default function TransferNotifications() {
  const [data, setData] = useState({ items: [], count: 0 });
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let active = true;
    const load = () => api.get('/branch-transfers/notifications').then(r => { if (active) setData(r.data); }).catch(() => {});
    load(); const timer = setInterval(load, 30000);
    window.addEventListener('branch-transfer-changed', load);
    return () => { active = false; clearInterval(timer); window.removeEventListener('branch-transfer-changed', load); };
  }, []);
  return <div className="relative z-20">
    <button type="button" className="theme-shortcut relative" aria-label="Notifikasi transfer cabang" aria-expanded={open} title="Transfer cabang" onClick={() => setOpen(v => !v)}>
      <BellRing size={19} />{data.count > 0 && <span className="absolute -right-1 -top-1 rounded-full bg-brand-button text-white text-[10px] px-1">{data.count > 9 ? '9+' : data.count}</span>}
    </button>
    {open && <section className="absolute right-0 top-11 w-[min(340px,calc(100vw-2rem))] rounded-xl border border-ui-line bg-ui-card shadow-xl p-3">
      <div className="flex justify-between mb-2"><strong className="text-sm">Transfer antar cabang</strong><button type="button" onClick={() => setOpen(false)} className="text-xs text-brand-readable">Tutup</button></div>
      <p className="text-xs text-ui-muted mb-2">Membaca pemberitahuan tidak memposting stok.</p>
      <div className="max-h-72 overflow-auto space-y-2">{data.items.map(d => <Link key={d.id} to={`/branch-transfers?open=${d.id}`} onClick={() => setOpen(false)} className="block rounded-lg bg-ui-soft p-2 text-xs"><strong className="block text-brand-readable">{d.number}</strong><span className="block">{d.title}</span><span className="text-ui-muted">{d.from} → {d.to}</span></Link>)}{!data.count && <p className="text-xs py-3 text-ui-muted">Tidak ada transfer yang menunggu.</p>}</div>
    </section>}
  </div>;
}
